import { NotFoundedI18n } from '@/locales/base.message.locales';

export const notFounded: NotFoundedI18n = {
    titles: {
        page_not_exists: 'Opa! A página que você estava procurando não existe.'
    },
    subtitles: {
        wrong_address: 'Você pode ter digitado incorretamente o endereço ou a página pode ter sido movida.'
    },
    buttons: {
        back_to_home: 'Ir para página inicial'
    }
}
